module.exports = __webpack_public_path__ + "static/media/NC_map@2x.cc53cb57.png";